import React, { useState, useEffect, useRef, useReducer } from "react"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"
import { Grid, LinearProgress } from "@mui/material"
import Container from "@mui/material/Container"
import { DataGrid, GridToolbar, faIR } from "@mui/x-data-grid"
import {  getTransactions } from "store/actions"
import { columnsClientGrid, columnsEngGrid, columnsGrid } from "./columns"
import { getCurrentUser } from "helpers/service_helper"
import { Box } from "@mui/system"
import "./transactions.scss"
import { green, red } from "@mui/material/colors"
const TransactionList = props => {
  const { lstTransactions, translate, loading, error } = props
  const [errorMessage, setErrorMessage] = useState(null)
  const [pageSize, setPageSize] = React.useState(8)
  
  useEffect(() => {
    setTimeout(() => {
      setErrorMessage(null)
    }, 3000)
  }, [errorMessage])

  useEffect(() => {
    props.onGetTransactions()
  }, [])
  return (
    <Container maxWidth="xl" >
    <Box
      sx={{
        backgroundColor: "#fff",
        margin: 2,
        paddingInline: 2,
        borderRadius: 2,
        "& .even": {
          backgroundColor: "rgb(240, 255, 255)",
        },
        "& .super-app.negative": {
          backgroundColor: "rgba(157, 255, 118, 0.49)",
          color: "#1a3e72",
          fontWeight: "600",
        },
        "& .super-app.positive": {
          backgroundColor: green[400],
          color: "#1a3e72",
          fontWeight: "600",
        },
        "& .super-app.disapproval": {
          backgroundColor: red[200],
          color: "#1a3e72",
          fontWeight: "600",
        },
        height: "100%",
      }}
    >
    
      <Grid className="transactions-list" item xs={12}>
              <Grid>
                    <Grid item xs={12}>
                      {errorMessage && errorMessage ? (
                        <Alert severity="error">{errorMessage}</Alert>
                      ) : null}
                      {props.error && props.error ? (
                        <Alert severity="error">{props.error}</Alert>
                      ) : null}
                      {props.success && props.success ? (
                        <Alert severity="success">{props.success}</Alert>
                      ) : null}
                    </Grid>
                  </Grid>
        <DataGrid
          autoHeight={true}
          rows={lstTransactions}
          components={{ Toolbar: GridToolbar, LoadingOverlay: LinearProgress }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={
            getCurrentUser().role === "Accountant"
              ? columnsClientGrid(translate)
              : getCurrentUser().role === "Engineer"?columnsEngGrid(translate): columnsGrid(translate)
          }
          pageSize={pageSize}
          onPageSizeChange={newPageSize => setPageSize(newPageSize)}
          rowsPerPageOptions={[8, 12, 50, 100]}
          getRowClassName={params =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
          }
          pagination
          loading={loading}
          getRowHeight={() => {
            return "auto"
                  }}
        />
      </Grid>
    </Box>

    </Container>

  )
}


const mapStateToProps = ({ Accounting }) => ({
  lstTransactions: Accounting.lstTransactions,
  error: Accounting.error,
  success: Accounting.success,
  loading: Accounting.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetTransactions: () => dispatch(getTransactions()),
})

export default connect(mapStateToProps, mapDispatchToProps)(TransactionList)
